/**
 * @generated SignedSource<<8c4c1caa2bcfb36e7036fb6d2b34bb34>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueKeyCell$data = {
  readonly id?: string;
  readonly text: string | null | undefined;
  readonly " $fragmentType": "IssueKeyCell";
};
export type IssueKeyCell$key = {
  readonly " $data"?: IssueKeyCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueKeyCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "IssueKeyCell",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "text"
    }
  ],
  "type": "JiraSingleLineTextField"
};

(node as any).hash = "19859c216ccec1d10cf9445cab889233";

export default node;
